import React from "react";
import { Link } from "@quintype/components";
import { array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import NewsHeadline from "../../atoms/NewsHeadline";
import ScrollSnap from "../../atoms/ScrollSnap";
import CardImage from "../../atoms/CardImage";
import PhotoStoryCard from "../PhotoStoryCard";
import { staticTexts } from "../../utils/Translate";

import "./photoRelatedStories.m.css";

const PhotoRelatedStories = ({ relatedStories, lang }) => (
  <div styleName="wrappper">
    <h2 styleName="related-story-heading">{staticTexts(lang).morePhotoStories}</h2>
    <div styleName="related-stories-wrapper-desktop">
      {relatedStories.map((item, index) => {
        return (
          <PhotoStoryCard key={index} story={item} aspectRatio={[3, 2]} imageType="image3x2" cardImageWidths={[200]} />
        );
      })}
    </div>
    <div styleName="related-stories-wrapper-mobile">
      <ScrollSnap isIndicator={false}>
        {relatedStories.map((item, index) => {
          return (
            <div styleName="also-read-story" key={index}>
              <Link aria-label={item.headline} href={item.url}>
                <h2 styleName="related-story-heading">{staticTexts(lang).readMore}</h2>
                <div styleName="hero-image">
                  <CardImage
                    story={item}
                    aspectRatio={[3, 2]}
                    imageType="image3x2"
                    showAlternateImage={true}
                    widths={[200]}
                  />
                </div>
                <NewsHeadline story={item} />
              </Link>
            </div>
          );
        })}
      </ScrollSnap>
    </div>
  </div>
);

PhotoRelatedStories.propTypes = {
  relatedStories: array.isRequired,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(PhotoRelatedStories);
